import { makeAutoObservable } from 'mobx';

import Billing from './billing';

export default class Plan {
  id?: string;
  old?: string;
  trialEnded?: boolean;
  hasActivePlan?: boolean;
  /** plain objects from `/plans`: `type`, `recordedSessions`, `endAt`, … */
  current: Record<string, any> = {};
  remaining: Record<string, any> = {};
  billing: Billing = new Billing();
  count: Record<string, any> = {};

  constructor(data: Partial<Plan> = {}) {
    Object.assign(this, data);
    this.billing = data.billing ? new Billing(data.billing) : new Billing();
    makeAutoObservable(this);
  }

  edit = (data: Partial<Plan>) => {
    Object.keys(data).forEach((key) => {
      if (key in this) {
        this[key] = data[key];
      } else {
        console.error(`Plan: Unknown key ${key}`);
      }
    });
    return this;
  };

  toSaveData = () => {
    return {
      name: this.billing.name,
      cardToken: this.billing.cardToken,
      address: this.billing.address.toData(),
    };
  };

  toData = () => {
    return {
      id: this.id,
      old: this.old,
      trialEnded: this.trialEnded,
      hasActivePlan: this.hasActivePlan,
      current: this.current,
      remaining: this.remaining,
      billing: this.billing.toData(),
      count: this.count,
    };
  };
}
